class MobileDock extends HTMLElement {
  constructor() {
    super();

    this.isAction = false;

    this.header = document.querySelector('sticky-header');

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
    document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));
    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));

    this.init();
  }

  init() {
    const delay = window.Shopify && Shopify.designMode ? 1 : parseInt(this.dataset.delay, 10);

    setTimeout(() => {
      this.classList.remove('hidden');
      this.classList.add('is-active');
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      });
    }, delay * 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const miniCart = document.querySelector('mini-cart');
        setTimeout(() => {
          if (miniCart) {
            miniCart.open();
          } else {
            window.location.href = window.routes?.cart_url || '/cart';
          }
          document.activeElement.blur();
        }, delay);
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawer = document.querySelector('header-drawer');
        setTimeout(() => {
          const summary = headerDrawer?.querySelector('summary');
          if (summary) {
            summary.click();
          }
          document.activeElement.blur();
        }, delay);
        break;

      case 'search':
        this.isAction = true;
        
        document.querySelectorAll('search-modal').forEach((searchModal) => {
          const style = window.getComputedStyle(searchModal);
          if (style.display === 'none') {
            return;
          }

          setTimeout(() => {
            const summary = searchModal.querySelector('summary');
            const input = searchModal.querySelector('input:not([type="hidden"])');
            if (!summary || !input) {
              return;
            }

            summary.click();
            
            input.focus();
          }, delay);
        });
        break;
    }
  }

  hideStickyHeader() {
    if (this.header && window.theme?.config?.mqlSmall && this.isAction && this.header.sticky()) {
      setTimeout(() => {
        this.header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  onCartUpdated(event) {
    try {
      const cart = typeof event.detail?.cart === 'string' ? JSON.parse(event.detail.cart) : event.detail?.cart;
      const itemCount = Number(cart?.item_count || 0);
      this.updateCartCount(itemCount);
    } catch (error) {
      return;
    }
  }

  updateCartCount(itemCount) {
    this.querySelectorAll('[data-mobile-dock-cart-count]').forEach((bubble) => {
      bubble.hidden = itemCount === 0;
      bubble.classList.toggle('mobile-dock__cart-count--dot', itemCount >= 100);
      bubble.setAttribute('aria-label', `${itemCount} cart items`);

      const visibleCount = bubble.querySelector('[aria-hidden="true"]');
      if (visibleCount) {
        visibleCount.textContent = itemCount < 100 ? itemCount : '';
      }
    });
  }

  waitStickyHeader() {
    if (this.header && !this.header.sticky() && !this.isElementVisible(this.header)) {
      this.header.hide();
      setTimeout(() => this.header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
if (!customElements.get('mobile-dock')) {
  customElements.define('mobile-dock', MobileDock);
}

/* =========================================================
   4PIXELS — PDP COLOR FACE DATA REPAIR
   Keeps real option names available to CSS even when legacy availability JS
   changes label title to SOLD OUT or removes it.
   ========================================================= */
(() => {
  const COLOR_MAP = {
    'black':'#000000','white':'#FFFFFF','off white':'#F8F6F0','off-white':'#F8F6F0','ivory':'#FFFFF0','cream':'#FFFDD0',
    'beige':'#F5F5DC','nude':'#D8A47F','powder pink':'#F4C2C2','powder-pink':'#F4C2C2','baby pink':'#F4C2C2',
    'pink':'#FFC0CB','rose':'#E8A0BF','red':'#D32F2F','burgundy':'#800020','wine':'#722F37','maroon':'#800000',
    'navy':'#000080','navy blue':'#000080','blue':'#1E5AA8','royal blue':'#4169E1','sky blue':'#87CEEB',
    'green':'#2E7D32','olive':'#808000','mint':'#98FF98','grey':'#808080','gray':'#808080','charcoal':'#36454F',
    'brown':'#8B4513','mocha':'#967969','chocolate':'#7B3F00','purple':'#800080','lavender':'#E6E6FA','lilac':'#C8A2C8',
    'yellow':'#F4D03F','orange':'#F39C12','gold':'#D4AF37','silver':'#C0C0C0',
    'أسود':'#000000','اسود':'#000000','أبيض':'#FFFFFF','ابيض':'#FFFFFF','أحمر':'#D32F2F','احمر':'#D32F2F',
    'وردي':'#FFC0CB','بينك':'#FFC0CB','بيج':'#F5F5DC','زيتوني':'#808000','كحلي':'#000080','نبيتي':'#800020',
    'أخضر':'#2E7D32','اخضر':'#2E7D32','رمادي':'#808080','موف':'#800080'
  };

  const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();

  const repairColorFaces = (scope = document) => {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('variant-radios label.color__swatch').forEach((label) => {
      let input = null;
      if (label.htmlFor) {
        try { input = document.getElementById(label.htmlFor); } catch (error) {}
      }
      if (!input || input.type !== 'radio') return;

      const value = String(input.dataset.optionValue || input.value || '').trim();
      if (!value) return;

      label.dataset.fpColorName = value;

      const soldOut = label.dataset.fpSoldout === 'true' || label.classList.contains('fp-option-soldout') || label.classList.contains('is-sold-out');
      label.setAttribute('title', value);
      label.setAttribute('aria-label', soldOut ? `${value} — Sold out` : value);

      const mapped = COLOR_MAP[normalize(value)];
      if (mapped && !label.style.backgroundImage) {
        label.style.setProperty('background-color', mapped, 'important');
      }
    });
  };

  let queued = false;
  const scheduleRepair = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      repairColorFaces(document);
      setTimeout(() => repairColorFaces(document), 40);
      setTimeout(() => repairColorFaces(document), 160);
    });
  };

  const init = () => {
    repairColorFaces(document);
    document.addEventListener('change', (event) => {
      if (event.target && event.target.matches('variant-radios input[type="radio"]')) scheduleRepair();
    }, true);

    ['variant:change','variant:changed','product:variant-change','shopify:section:load'].forEach((eventName) => {
      document.addEventListener(eventName, scheduleRepair);
    });

    if (window.MutationObserver) {
      const observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => {
          const target = mutation.target;
          return target && target.matches && target.matches('variant-radios label.color__swatch');
        })) scheduleRepair();
      });
      document.querySelectorAll('variant-radios').forEach((picker) => {
        observer.observe(picker, { subtree:true, attributes:true, attributeFilter:['class','data-fp-soldout','aria-disabled'] });
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
